import { MessageSquare, HelpCircle, Mail } from 'lucide-react';

export const faqHeroContent = {
  titlePrefix: "Frequently Asked",
  titleHighlight: "Questions",
  description:
    "Find answers to common questions about JobScribe. Can't find what you're looking for? Contact our support team.",
};

export const faqCategories = [
  {
    title: "General Questions",
    items: [
      {
        question: "What is JobScribe?",
        answer: "JobScribe is an intelligent automation platform designed specifically for recruitment agencies and consultancies to streamline their job sourcing and candidate matching processes."
      },
      {
        question: "How does JobScribe work?",
        answer: "JobScribe connects to various job boards and platforms, automatically aggregating relevant job postings based on your criteria, and helps match them with your candidate database using advanced algorithms."
      },
      {
        question: "What makes JobScribe different from other job scraping tools?",
        answer: "Unlike basic scraping tools, JobScribe offers deep integration with Indian job portals, intelligent candidate matching, automated workflow features, and a centralized dashboard designed explicitly for consultancy workflows."
      },
      {
        question: "Is JobScribe available in my country?",
        answer: "Currently, JobScribe is optimized for the Indian job market, supporting major regional platforms and consultancies operating within India."
      }
    ]
  },
  {
    title: "Pricing & Plans",
    items: [
      {
        question: "How much does JobScribe cost?",
        answer: "We offer flexible pricing tiers designed to scale with your agency. Please visit our Pricing page for detailed information on our current plans and features included in each tier."
      },
      {
        question: "Do you offer a free trial?",
        answer: "Yes, we offer a 14-day free trial on our standard plans so you can test the platform's capabilities before making a commitment."
      },
      {
        question: "Can I change my plan later?",
        answer: "Absolutely. You can upgrade or downgrade your plan at any time from your account dashboard. Changes are prorated for your current billing cycle."
      },
      {
        question: "What payment methods do you accept?",
        answer: "We accept all major credit cards, debit cards, and standard business payment methods like wire transfers for annual enterprise plans."
      }
    ]
  },
  {
    title: "Technical Questions",
    items: [
      {
        question: "Can I integrate JobScribe with my existing ATS?",
        answer: "Yes, JobScribe offers seamless integration with many popular Applicant Tracking Systems (ATS) and CRM platforms used in the recruitment industry."
      },
      {
        question: "Is there an API available?",
        answer: "Yes, we provide a robust RESTful API for our Enterprise customers, allowing deep integration into your custom internal tools and workflows."
      },
      {
        question: "How secure is my data with JobScribe?",
        answer: "Security is our top priority. We employ enterprise-grade encryption for data at rest and in transit, and adhere to strict privacy standards to ensure your candidate and client data remains completely secure."
      },
      {
        question: "Can I export data from JobScribe?",
        answer: "Yes, you can easily export your data in various standard formats including CSV and Excel, ensuring you maintain full control over your information."
      }
    ]
  },
  {
    title: "Account Management",
    items: [
      {
        question: "How many users can I add to my account?",
        answer: "The number of users depends on your specific subscription plan. Our Team and Enterprise plans offer options for multiple user accounts with customizable permission levels."
      },
      {
        question: "How do I reset my password?",
        answer: "You can reset your password simply by clicking the 'Forgot Password' link on the login page and following the instructions sent to your registered email address."
      },
      {
        question: "Can I change my company information after registration?",
        answer: "Yes, account administrators can update company details, billing information, and user settings at any time from the account management dashboard."
      },
      {
        question: "How do I cancel my subscription?",
        answer: "You can cancel your subscription at any time from your account billing settings. You will retain access until the end of your current billing period."
      }
    ]
  }
];

export const faqHelpSection = {
  badge: "Need More Help?",
  headingPart1: "We're here to ",
  headingHighlight: "help",
  options: [
    {
      icon: MessageSquare,
      title: "Live Chat Support",
      description:
        "Chat directly with our support team during business hours for immediate assistance.",
      buttonText: "Start Chat",
      link: "/contact",
    },
    {
      icon: HelpCircle,
      title: "Support Center",
      description:
        "Browse our comprehensive knowledge base with tutorials and guides.",
      buttonText: "Visit Support Center",
      link: "/support",
    },
    {
      icon: Mail,
      title: "Email Support",
      description: "Send us an email and we'll get back to you within 24 hours.",
      buttonText: "Contact Us",
      link: "/contact",
    },
  ],
};

/** @deprecated Use faqHelpSection.options */
export const helpCards = faqHelpSection.options;
